import { Termin } from '../model';
import { Kosten } from '../model/kosten';

export const testTermin: Termin = {
  id: '1',
  beginn: Date.parse('2020-07-09T00:00:00.000Z').valueOf(),
  dauer: { id: 3, bezeichnung: '1 Monat' },
  unterrichtsform: {
    id: 0,
    bezeichnung: 'Präsenzberanstaltung'
  },
  unterrichtszeit: {
    id: 0,
    bezeichnung: 'Vollzeit'
  },
  kostenWert: Kosten.UEBER_1000_BIS_5000_EUR,
  kostenWaehrung: '€',
  kostenBemerkung: '',
  ansprechpartner: [],
  bemerkung: 'Bemerkung',
  ende: Date.parse('2020-08-09T00:00:00.000Z').valueOf(),
  adresse: {
    id: 3,
    bezeichnung: 'Adresse',
    hinweise: 'Ein Hinweis',
    //ortStrasse: { id: 1, name: 'Rostock', plz: '18055' },
    ort: 'Wintersdorf',
    plz: '04610',
    strasse: 'Schwaaner Landenstraße 8',
    barrierefrei: false
  },
  quelle: { id: 'kursnet', fremdschluessel: 'whatever' }
};
